
export const CONTACT_SUPPORT = "CONTACT_SUPPORT"
export const SERVICE_MANAGEMENT_LIST = "SERVICE_MANAGEMENT_LIST"
export const SERVICE_MANAGEMENT_ADD = "SERVICE_MANAGEMENT_ADD"
export const SERVICE_MANAGEMENT_DELETE = "SERVICE_MANAGEMENT_DELETE"
export const SERVICE_MANAGEMENT_STATUS = "SERVICE_MANAGEMENT_STATUS"
export const SERVICE_MANAGEMENT_DETAIL = "SERVICE_MANAGEMENT_DETAIL"
export const SERVICE_MANAGEMENT_UPDATE = "SERVICE_MANAGEMENT_UPDATE"


// Dashboard Detail
export const DASHBOARD_DETAIL = "DASHBOARD_DETAIL"
export const DASHBOARD_BOOKING_DETAIL = "DASHBOARD_BOOKING_DETAIL"
export const DASHBOARD_BOOKING_VIEW_DETAIL = "DASHBOARD_BOOKING_VIEW_DETAIL"

export const DASHBOARD_STATUS_CHANGE_BOOKING = "DASHBOARD_STATUS_CHANGE_BOOKING"
export const DASHBOARD_MARK_AS_COMPLETED_BOOKING = "DASHBOARD_MARK_AS_COMPLETED_BOOKING"
export const BOOKING_SERVICE_REMOVE = "BOOKING_SERVICE_REMOVE"
export const BOOKING_MARK_AS_COMPLETED = "BOOKING_MARK_AS_COMPLETED"


// canbookin
export const CANBOOKIN_LIST_REASON = "CANBOOKIN_LIST_REASON"
export const OFFLINE_BOOKING_CREATE = "OFFLINE_BOOKING_CREATE"
